export const HttpHeaders = () => {
  const headerconfig = {
    headers: {
      "Content-Type": "application/json",
      //"Access-Control-Allow-Origin": "*"
    },
  };
  return headerconfig;
};
